import { Divider } from "@vesatogo/grass-core"
import { inr } from "@vesatogo/utils"

export const UserCreditSummary = ({ credit }) => {
  return (
    <div className="flex flex-wrap gap-2 text-[10px]  px-2 md:px-4 pt-4 text-center justify-center">
      <div className="flex justify-between !text-center">
        <div className="grid grid-rows-2 w-full">
          <span>Credit Limit</span>
          <span className="text-blue-300 font-700 text-xs">
            {inr(credit?.credit_limit || 0)}
          </span>
        </div>
      </div>
      <Divider />
      <div className="flex justify-between">
        <div className="grid grid-rows-2 w-full">
          <span>Total exposure</span>
          <span className="text-blue-300 font-700 text-xs">
            {inr(credit?.total_exposure || 0)}
          </span>
        </div>
      </div>
      <Divider />
      <div className="flex justify-between">
        <div className="grid grid-rows-2 w-full">
          <span>Actual Exposure</span>
          <span className="text-red font-700 text-xs">
            {inr(credit?.actual_exposure || 0)}
          </span>
        </div>
      </div>
      <Divider />
      <div className="flex justify-between">
        <div className="grid grid-rows-2 w-full">
          <span>Shadow Exposure</span>
          <span className="text-blue-300 font-700 text-xs">
            {inr(credit?.shadow_exposure || 0) || "--"}
          </span>
        </div>
      </div>
      <Divider />
      <div className="flex justify-between">
        <div className="grid grid-rows-2 w-full">
          <span>Credit Limit Available</span>
          <span className="text-green font-700 text-xs">
            {inr(credit?.credit_limit_available || 0)}
          </span>
        </div>
      </div>
      <Divider />
      <div className="grid grid-rows-2">
        <span>Overdue Amt</span>
        <span className="text-red font-700 text-xs">
          {inr(credit?.overdue_amount || 0)}
        </span>
      </div>
      <Divider />
      <div className="grid grid-rows-2">
        <span>Avg. Overdue</span>
        <span className="text-red font-700 text-xs">
          {credit?.avg_overdue_days || "--"}
        </span>
      </div>
      <Divider />
      <div className="grid grid-rows-2">
        <span>Balance Amount</span>
        <span className="text-brown-500 font-700 text-xs">
          {inr(credit?.department_settlement_remaining_amount || 0)}
        </span>
      </div>
      <Divider />
      <div className="grid grid-rows-2">
        <span>Overdue Count</span>
        <span className="text-red font-700 text-xs">
          {credit?.overdue_count || "--"}
        </span>
      </div>
      <Divider />
      <div className="grid grid-rows-2">
        <span>Overdraft amount</span>
        <span className="text-red font-700 text-xs">
          {inr(credit?.used_overdraft || 0)}
        </span>
      </div>
      <Divider />
      {/* <div className="grid grid-rows-2">
        <span>Deviation Amt. Req.</span>
        <span className="text-yellow-500 font-700 text-xs">
          {inr(credit?.requested_overdraft_amt || 0)}
        </span>
      </div>
      <Divider />
      <div className="grid grid-rows-2">
        <span>Deviation O/S Approved Amt.</span>
        <span className="text-yellow-500 font-700 text-xs">
          {inr(credit?.approved_overdraft_amt || 0)}
        </span>
      </div> */}
    </div>
  )
}
